import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';

import SplitType from 'split-type';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Split text into spans
const textSplitElements = document.querySelectorAll('[data-text-split]');
textSplitElements.forEach(element => {
  const splitText = new SplitType(element, {
    type: ['words', 'chars'],
    tagName: 'span',
  });
  splitText.split();
});

// Link timelines to scroll position
function createScrollTrigger(triggerElement, timeline) {
  ScrollTrigger.create({
    trigger: triggerElement,
    start: "top 85%",
    end: "bottom center",
    onEnter: () => timeline.play(),
  });
}

// Animation types
const animationTypes = {
  'content-slide-up': {
    elementType: 'default',
    opacity: 0,
    yPercent: '20',
    duration: 1.5,
    ease: 'power2',
    stagger: 0.05,
  },
  'content-from-left': {
    elementType: 'default',
    opacity: 0,
    xPercent: '-100',
    duration: 1.5,
    ease: 'power4.out',
    stagger: 0.25,
  },
  'content-from-right': {
    elementType: 'default',
    opacity: 0,
    xPercent: '100',
    duration: 1.5,
    ease: 'power4.out',
    stagger: 0.25,
  },
  'content-fade-in': {
    elementType: 'default',
    opacity: 0,
    duration: 1.5,
    ease: 'power1.out',
    stagger: { amount: 0.45 },
  },
  'tagline-slide-up': {
    elementType: 'default',
    opacity: 0,
    duration: 1,
    ease: 'power1.out',
    stagger: 0.05,
  },
  'tagline-from-left': {
    elementType: 'default',
    opacity: 0,
    xPercent: '-100',
    duration: 1,
    ease: 'expo.out',
    stagger: 0.25,
  },
  'tagline-from-right': {
    elementType: 'default',
    opacity: 0,
    xPercent: '100',
    duration: 1,
    ease: 'power4.out',
    stagger: 0.25,
  },
  'words-rotate-in': {
    elementType: 'words',
    opacity: 0,
    rotationX: -90,
    duration: 0.6,
    ease: 'power2.out',
    stagger: { amount: 0.6 },
  },
  'words-slide-up': {
    elementType: 'words',
    opacity: 0,
    yPercent: 50,
    duration: 0.5,
    ease: 'back.out(2)',
    stagger: { amount: 0.5 },
  },
  'words-slide-from-right': {
    elementType: 'words',
    opacity: 0,
    x: '1em',
    duration: 0.6,
    ease: 'power2.out',
    stagger: { amount: 0.2 },
  },
  'words-slide-from-left': {
    elementType: 'words',
    opacity: 0,
    x: '-1em',
    duration: 0.6,
    ease: 'power2.out',
    stagger: { amount: 0.2 },
  },
  'letters-slide-up': {
    elementType: 'chars',
    opacity: 0,
    yPercent: 100,
    duration: 0.1,
    ease: 'power1.out',
    stagger: { amount: 0.6 },
  },
  'letters-slide-down': {
    elementType: 'chars',
    opacity: 0,
    yPercent: -120,
    duration: 0.3,
    ease: 'power1.out',
    stagger: { amount: 0.7 },
  },
  'letters-fade-in': {
    elementType: 'chars',
    opacity: 0,
    duration: 0.4,
    ease: 'power3.out',
    stagger: { 
      each: 0.035 // Add a delay of 0.1 seconds between each letter
    },
  },
  'letters-fade-in-random': {
    elementType: 'chars',
    opacity: 0,
    duration: 0.05,
    ease: 'power1.out',
    stagger: { amount: 0.4, from: 'random' },
  },
};

// Apply animation to target with a specific animation type
function applyAnimation(target, animationType) {
  const animationConfig = animationTypes[animationType];

  if (animationConfig) {
    const { elementType, ...config } = animationConfig;

    const tl = gsap.timeline({ paused: true });

    if (elementType === 'words') {
      const words = target.querySelectorAll('.word');
      tl.set(words, { transformPerspective: 1000 });
      tl.from(words, {
        ...config,
      });
    } else if (elementType === 'chars') {
      const chars = target.querySelectorAll('.char');
      tl.from(chars, {
        ...config,
      });
    } else {
      tl.from(target, {
        ...config,
      });
    }
    createScrollTrigger(target, tl);
  }
}

const elements = document.querySelectorAll('[data-animation]');
elements.forEach(element => {
  const animationType = element.dataset.animation;
  applyAnimation(element, animationType);
});

if (document.querySelector('[data-text-split]')) {
  gsap.set('[data-text-split]', { opacity: 1 });
}
